import { useSelector } from 'react-redux';
import { useHomeSlice } from 'app/pages/Home/slice';
import { selectTimelineViewMode } from '../store/selectors';
import { useDeferredViewTransition } from './useDeferredViewTransition';

export function useTimelineViewTransition() {
  const timelineViewMode = useSelector(selectTimelineViewMode);
  const { actions } = useHomeSlice();

  const { active, displayed } = useDeferredViewTransition(
    timelineViewMode,
    actions.setTimelineViewTransitioning
  );

  return {
    timelineViewMode: active,
    displayedTimelineViewMode: displayed
  };
}
